import autoBind from 'auto-bind'

export abstract class BaseMiddlewareGql {
  // @ts-ignore
  protected app: any

  constructor(app: any) {
    autoBind(this)
    this.app = app
  }

  public abstract default(args: any, ctx: { req: any; res: any; next: any }, info: any): void
}
